module.exports = __webpack_public_path__ + "img/mp3Icon.f6de3a08.svg";